module.exports = __webpack_public_path__ + "img/Logo-14.a3171693.svg";